// @flow
import importWithRetry from 'mz-utils/importWithRetry'

/**
 * Get all cruise lines
 * @return {Promise|Error}
 */
export const getTrainCompanies = (): Promise<String[]> =>
  importWithRetry(() =>
    import(/* webpackChunkName: "cruise-lines" */ './trainCompanies')
  ).then((module) => module.default)

export default getTrainCompanies
